import api, { ApiResponse } from "../api";
import { apiQueryAdapter } from "../apiQueryAdapter";
import { DriverDutyDetail, DriverRequest, DriverResponse, DriversApiResponse, DriversDutyDetailRequest, tableSize } from "./models";

class DriverService {
  private static instance: DriverService;

  private constructor() { }

  static getInstance(): DriverService {
    if (!DriverService.instance) {
      DriverService.instance = new DriverService();
    }
    return DriverService.instance;
  }

  public getDrivers = async (domicileTerminalNumber: string, 
    search: string, cursor: number): Promise<ApiResponse<DriversApiResponse>> => {
    const params = new URLSearchParams();
    params.set("limit", tableSize.toString());

    if(domicileTerminalNumber){
      params.set("domicileTerminalNumber", domicileTerminalNumber.toString());
    }
    if(cursor){
      params.set("cursor", cursor.toString());
    }

    const url = search ? `/driver/drivers?search=${encodeURIComponent(search)}` : `/driver/drivers`;
    const response = await apiQueryAdapter.query(
      url,
      "GET",
      { params }
    );
    
    return response;
    };

  public getDriver = async (driverId: string): Promise<ApiResponse<DriverResponse>> => {
    const response = await apiQueryAdapter.query(
      `/driver/drivers/${driverId}`,
      "GET"
    );
    return response;
  };

  public updateDriver = async (driverId: string, driver: DriverRequest): Promise<ApiResponse<DriverResponse>> => {
    const response = await apiQueryAdapter.query(
      `/driver/drivers/${driverId}`,
      "PUT",
      { body: driver }
    );
    return response.data;
  };

  public getDriversDutyDetails = async (
    requestData: DriversDutyDetailRequest
  ): Promise<ApiResponse<[DriverDutyDetail]>> => {
    return await api.get(
     "/driver/drivers-duty",
      { params: requestData }
    );
  };

}

export default DriverService;